import style from '../../../scss/engine/baleset/style.scss';
import engine_core from '../../frontend/src/engine_core';

class engine extends engine_core {

}

export default engine